import { IconProps } from "../../models/Icon";

export function FolderIcon({ size = 20, color = "#000", opacity="1"}: IconProps) {
    return(
        <svg 
            width={size} 
            height={size} 
            viewBox="0 0 36 28" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M34.7143 11.263H30.375V6.69867C30.375 5.98751 29.8004 5.41296 29.0893 5.41296H16.433L11.7201 0.904921C11.6601 0.848783 11.5812 0.817233 11.4991 0.816528H1.28571C0.574554 0.816528 0 1.39108 0 2.10224V25.888C0 26.5991 0.574554 27.1737 1.28571 27.1737H29.3304C29.8527 27.1737 30.3268 26.8563 30.5237 26.3701L35.9076 13.0308C35.9679 12.8781 36 12.7134 36 12.5487C36 11.8375 35.4254 11.263 34.7143 11.263ZM2.89286 3.70939H10.4665L15.2719 8.30581H27.4821V11.263H6.99107C6.46875 11.263 5.99464 11.5804 5.79777 12.0665L2.89286 19.2665V3.70939ZM28.4183 24.2808H3.81696L7.96741 13.9951H32.5728L28.4183 24.2808Z" 
                fill={color} 
                opacity={opacity}
            />
        </svg>
    )
}



